var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletConnect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 12.871",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "walletconnect-square-black",
    transform: "translate(-10.617 -12.26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(10.617 12.26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "walletconnect-circle-white"
  }, /*#__PURE__*/React.createElement("path", {
    id: "WalletConnect",
    d: "M107.3,162.515a8.9,8.9,0,0,1,12.4,0l.412.4a.423.423,0,0,1,0,.607l-1.41,1.38a.223.223,0,0,1-.31,0l-.567-.555a6.21,6.21,0,0,0-8.652,0l-.607.595a.223.223,0,0,1-.31,0l-1.41-1.38a.423.423,0,0,1,0-.607l.452-.443Zm15.318,2.855,1.255,1.229a.423.423,0,0,1,0,.607l-5.658,5.54a.445.445,0,0,1-.62,0l-4.016-3.932a.111.111,0,0,0-.155,0l-4.016,3.932a.445.445,0,0,1-.62,0l-5.658-5.54a.423.423,0,0,1,0-.607l1.255-1.229a.445.445,0,0,1,.62,0l4.016,3.932a.111.111,0,0,0,.155,0l4.016-3.932a.445.445,0,0,1,.62,0l4.016,3.932a.111.111,0,0,0,.155,0L122,165.37a.445.445,0,0,1,.62,0Z",
    transform: "translate(-103 -160.001)",
    fill: "#3b99fc"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletConnect);
export default __webpack_public_path__ + "static/media/wallet-connect.23303f8b7c79e2b91c3d5abf848cdf26.svg";
export { ForwardRef as ReactComponent };